import ResetConfirmation from '@appViews/Login/ResetConfirmation';
import BoAuthService from '@boServices/boAuthService';
import FlexBox from '@sharedComponents/FlexBox';
import ForgottenPassword from '@sharedComponents/ForgottenPassword';
import LoginFooter from '@sharedComponents/LoginFooter';
import LoginHeader from '@sharedComponents/LoginHeader';
import SplitLayout from '@sharedComponents/SplitLayout';
import { useEffect, useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';

const boAuthService = new BoAuthService();

export default function BoResetPassword() {
    const navigate = useNavigate();
    const [searchParams] = useSearchParams();
    const token = searchParams.get('token') ?? null;
    const [displayedElement, setDisplayedElement] = useState(token ? 'resetConfirmation' : 'forgotPassword');
    const [resetLinkExpired, setResetLinkExpired] = useState(false);

    useEffect(() => {
        if (!token) {
            setDisplayedElement('forgotPassword');
            setResetLinkExpired(true);
        }
    }, [token]);

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: 'smooth' });
    }, [displayedElement]);

    const handleSavePassword = async (newPassword) => {
        try {
            await boAuthService.confirmPasswordReset(token, newPassword);
            sessionStorage.setItem('passwordResetSuccess', '1');
            navigate('/login');
        } catch (err) {
            if (err?.status === 401) {
                setResetLinkExpired(true);
                setDisplayedElement('forgotPassword');
                return;
            }
            throw err;
        }
    };

    return (
        <SplitLayout imageType="LOGIN" backgroundColor="primary">
            <FlexBox flexDirection="column" gap="xl" additionnalStyles={{ width: '100%', maxWidth: '700px', margin: '0 auto' }}>
                <LoginHeader />
                {displayedElement === 'resetConfirmation' && <ResetConfirmation email="" onSave={handleSavePassword} />}
                {displayedElement === 'forgotPassword' && (
                    <ForgottenPassword
                        onSendEmail={(email) => boAuthService.requestPasswordReset(email)}
                        onBack={() => navigate('/login')}
                        expired={resetLinkExpired}
                    />
                )}
                <LoginFooter />
            </FlexBox>
        </SplitLayout>
    );
}
